@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.share_account.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.share_account.generated.resources/"

internal val Res.string.feature_share_account: StringResource by lazy {
      StringResource("string:feature_share_account", "feature_share_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1894, 49),
      ))
    }

internal val Res.string.feature_share_account_action_charges: StringResource by lazy {
      StringResource("string:feature_share_account_action_charges", "feature_share_account_action_charges", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92, 56),
      ))
    }

internal val Res.string.feature_share_account_action_charges_subtitle: StringResource by lazy {
      StringResource("string:feature_share_account_action_charges_subtitle", "feature_share_account_action_charges_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 81),
      ))
    }

internal val Res.string.feature_share_account_action_qr_code: StringResource by lazy {
      StringResource("string:feature_share_account_action_qr_code", "feature_share_account_action_qr_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231, 56),
      ))
    }

internal val Res.string.feature_share_account_action_qr_code_subtitle: StringResource by lazy {
      StringResource("string:feature_share_account_action_qr_code_subtitle", "feature_share_account_action_qr_code_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149, 81),
      ))
    }

internal val Res.string.feature_share_account_action_transactions: StringResource by lazy {
      StringResource("string:feature_share_account_action_transactions", "feature_share_account_action_transactions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 375, 65),
      ))
    }

internal val Res.string.feature_share_account_action_transactions_subtitle: StringResource by lazy {
      StringResource("string:feature_share_account_action_transactions_subtitle", "feature_share_account_action_transactions_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288, 86),
      ))
    }

internal val Res.string.feature_share_account_activation_date: StringResource by lazy {
      StringResource("string:feature_share_account_activation_date", "feature_share_account_activation_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 441, 65),
      ))
    }

internal val Res.string.feature_share_account_active: StringResource by lazy {
      StringResource("string:feature_share_account_active", "feature_share_account_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 507, 44),
      ))
    }

internal val Res.string.feature_share_account_application_date: StringResource by lazy {
      StringResource("string:feature_share_account_application_date", "feature_share_account_application_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 552, 70),
      ))
    }

internal val Res.string.feature_share_account_approval_pending: StringResource by lazy {
      StringResource("string:feature_share_account_approval_pending", "feature_share_account_approval_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 623, 70),
      ))
    }

internal val Res.string.feature_share_account_approved: StringResource by lazy {
      StringResource("string:feature_share_account_approved", "feature_share_account_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 760, 50),
      ))
    }

internal val Res.string.feature_share_account_approved_shares: StringResource by lazy {
      StringResource("string:feature_share_account_approved_shares", "feature_share_account_approved_shares", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 694, 65),
      ))
    }

internal val Res.string.feature_share_account_closed: StringResource by lazy {
      StringResource("string:feature_share_account_closed", "feature_share_account_closed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 811, 44),
      ))
    }

internal val Res.string.feature_share_account_currency: StringResource by lazy {
      StringResource("string:feature_share_account_currency", "feature_share_account_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 856, 50),
      ))
    }

internal val Res.string.feature_share_account_dashboard: StringResource by lazy {
      StringResource("string:feature_share_account_dashboard", "feature_share_account_dashboard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 907, 63),
      ))
    }

internal val Res.string.feature_share_account_details_action: StringResource by lazy {
      StringResource("string:feature_share_account_details_action", "feature_share_account_details_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 971, 56),
      ))
    }

internal val Res.string.feature_share_account_details_top_bar_title: StringResource by lazy {
      StringResource("string:feature_share_account_details_top_bar_title", "feature_share_account_details_top_bar_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1028, 79),
      ))
    }

internal val Res.string.feature_share_account_empty_share_accounts: StringResource by lazy {
      StringResource("string:feature_share_account_empty_share_accounts", "feature_share_account_empty_share_accounts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1108, 110),
      ))
    }

internal val Res.string.feature_share_account_generic_error_server: StringResource by lazy {
      StringResource("string:feature_share_account_generic_error_server", "feature_share_account_generic_error_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1219, 150),
      ))
    }

internal val Res.string.feature_share_account_items: StringResource by lazy {
      StringResource("string:feature_share_account_items", "feature_share_account_items", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1370, 51),
      ))
    }

internal val Res.string.feature_share_account_market_price: StringResource by lazy {
      StringResource("string:feature_share_account_market_price", "feature_share_account_market_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1422, 58),
      ))
    }

internal val Res.string.feature_share_account_number: StringResource by lazy {
      StringResource("string:feature_share_account_number", "feature_share_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1481, 56),
      ))
    }

internal val Res.string.feature_share_account_pending_shares: StringResource by lazy {
      StringResource("string:feature_share_account_pending_shares", "feature_share_account_pending_shares", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1538, 64),
      ))
    }

internal val Res.string.feature_share_account_product_name: StringResource by lazy {
      StringResource("string:feature_share_account_product_name", "feature_share_account_product_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1603, 58),
      ))
    }

internal val Res.string.feature_share_account_purchased_date: StringResource by lazy {
      StringResource("string:feature_share_account_purchased_date", "feature_share_account_purchased_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1662, 64),
      ))
    }

internal val Res.string.feature_share_account_purchased_shares: StringResource by lazy {
      StringResource("string:feature_share_account_purchased_shares", "feature_share_account_purchased_shares", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1727, 70),
      ))
    }

internal val Res.string.feature_share_account_rejected: StringResource by lazy {
      StringResource("string:feature_share_account_rejected", "feature_share_account_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1798, 50),
      ))
    }

internal val Res.string.feature_share_account_status: StringResource by lazy {
      StringResource("string:feature_share_account_status", "feature_share_account_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1849, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_share_account", Res.string.feature_share_account)
  map.put("feature_share_account_action_charges", Res.string.feature_share_account_action_charges)
  map.put("feature_share_account_action_charges_subtitle", Res.string.feature_share_account_action_charges_subtitle)
  map.put("feature_share_account_action_qr_code", Res.string.feature_share_account_action_qr_code)
  map.put("feature_share_account_action_qr_code_subtitle", Res.string.feature_share_account_action_qr_code_subtitle)
  map.put("feature_share_account_action_transactions", Res.string.feature_share_account_action_transactions)
  map.put("feature_share_account_action_transactions_subtitle", Res.string.feature_share_account_action_transactions_subtitle)
  map.put("feature_share_account_activation_date", Res.string.feature_share_account_activation_date)
  map.put("feature_share_account_active", Res.string.feature_share_account_active)
  map.put("feature_share_account_application_date", Res.string.feature_share_account_application_date)
  map.put("feature_share_account_approval_pending", Res.string.feature_share_account_approval_pending)
  map.put("feature_share_account_approved", Res.string.feature_share_account_approved)
  map.put("feature_share_account_approved_shares", Res.string.feature_share_account_approved_shares)
  map.put("feature_share_account_closed", Res.string.feature_share_account_closed)
  map.put("feature_share_account_currency", Res.string.feature_share_account_currency)
  map.put("feature_share_account_dashboard", Res.string.feature_share_account_dashboard)
  map.put("feature_share_account_details_action", Res.string.feature_share_account_details_action)
  map.put("feature_share_account_details_top_bar_title", Res.string.feature_share_account_details_top_bar_title)
  map.put("feature_share_account_empty_share_accounts", Res.string.feature_share_account_empty_share_accounts)
  map.put("feature_share_account_generic_error_server", Res.string.feature_share_account_generic_error_server)
  map.put("feature_share_account_items", Res.string.feature_share_account_items)
  map.put("feature_share_account_market_price", Res.string.feature_share_account_market_price)
  map.put("feature_share_account_number", Res.string.feature_share_account_number)
  map.put("feature_share_account_pending_shares", Res.string.feature_share_account_pending_shares)
  map.put("feature_share_account_product_name", Res.string.feature_share_account_product_name)
  map.put("feature_share_account_purchased_date", Res.string.feature_share_account_purchased_date)
  map.put("feature_share_account_purchased_shares", Res.string.feature_share_account_purchased_shares)
  map.put("feature_share_account_rejected", Res.string.feature_share_account_rejected)
  map.put("feature_share_account_status", Res.string.feature_share_account_status)
}
